import React, { useEffect, useState } from 'react';
import { FaCheckCircle } from "react-icons/fa";
import { FaTimesCircle } from "react-icons/fa";
import SummaryApi from '../common';
import AdminSubCategoryCard from '../components/AdminSubCategoryCard';
import UploadSubCategory from '../components/UploadSubCategory';
import { toast } from 'react-toastify';

const AllSubCategory = () => {
  const [openUploadBrand, setOpenUploadBrand] = useState(false);
  const [allSubCategory, setAllSubCategory] = useState([]);

  const fetchAllSubCategory = async () => {
    try {
      const response = await fetch(SummaryApi.adminSubCategory.url, {
        headers: {
          'Authorization': 'Bearer oakyaecom_no_units_916',
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error('Failed to fetch subcategories');
      }
      
      const dataResponse = await response.json();
  
      // Reverse the data
      const reversedSubCategories = (dataResponse?.data || []).reverse();
      setAllSubCategory(reversedSubCategories);
    } catch (error) {
      console.error('Error fetching subcategories:', error);
      toast.error(`Failed to fetch subcategories: ${error.message}`);
    }
  };
  
  useEffect(() => {
    fetchAllSubCategory();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className='bg-white py-3 px-4 flex flex-col sm:flex-row justify-between items-center shadow-sm'>
        <h2 className='font-bold text-xl text-gray-800'>All Sub Categories</h2>
        
        <div className='flex items-center gap-6 mt-3 sm:mt-0'>
          <div className='flex items-center text-sm text-gray-600'>
            <span>Active</span>
            <FaCheckCircle className='mx-2 text-lg text-green-600' />
            <span className='ml-3'>Inactive</span>
            <FaTimesCircle className='mx-2 text-lg text-red-600' />
          </div>
          
          <button
            className='border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white transition-all py-1.5 px-4 rounded-full font-medium'
            onClick={() => setOpenUploadBrand(true)}
          >
            Upload Sub Category
          </button>
        </div>
      </div>

      {allSubCategory.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-20 px-4 text-center">
          <img
            src="https://img.freepik.com/free-vector/no-data-concept-illustration_114360-536.jpg"
            alt="No subcategories found"
            className="w-64 md:w-80 mb-6 opacity-90"
          />
          <h3 className="text-xl font-semibold text-gray-700 mb-2">
            No Sub Categories Yet
          </h3>
          <p className="text-gray-500 mb-6 max-w-md">
            You haven't added any sub categories. Click the button above to create your first one!
          </p>
          <button
            className='bg-red-600 text-white hover:bg-red-700 transition-all py-2 px-6 rounded-full font-medium'
            onClick={() => setOpenUploadBrand(true)}
          >
            Add Sub Category
          </button>
        </div>
      ) : (
        <div className='flex items-center flex-wrap gap-5 py-6 px-4 overflow-y-auto min-h-[400px]'>
          {allSubCategory.map((product, index) => (
            <AdminSubCategoryCard 
              key={index} 
              data={product} 
              fetchdata={fetchAllSubCategory} 
            />
          ))}
        </div>
      )}

      {openUploadBrand && (
        <UploadSubCategory 
          onClose={() => setOpenUploadBrand(false)} 
          fetchdata={fetchAllSubCategory} 
        />
      )}
    </div>
  );
};

export default AllSubCategory;